
export default {
    spacingDebug: true,
    inheritAttrs: false,
    components: {
        ButtonTemplate: () => import("~/components/global/templates/ButtonTemplate"),
        IconTemplate: () => import("~/components/global/templates/IconTemplate"),
    },
    props: {
        label: { type: String, default: "Close" },
        disabled: { type: Boolean, default: false },
    },
};
